<template>
    <div class="completion-page">
        <div class="construction-status">
            <!--     房屋信息       -->
            <div class="room-basic-info-content">
                <!--        业主信息        -->
                <div class="owner-info">
                    <img :src="require('@/assets/images/user/house/completion-working-icon.png')" alt="" class="head-image">
                    <div class="text-content ">
                        <p class="address">{{ '上海市嘉定区金鼎湾9栋909室样板间空调新风壁挂炉（地暖）项目' }}</p>
                        <p class="name">
                            <span class="first">{{ '王小小' }}</span>
                            <!-- <span>{{ 'NO.2021080907655' }}</span> -->
                        </p>
                    </div>
                </div>
                <!--        房屋信息        -->
                <div class="room-info">
                    <div class="room-info-item" v-for="(item,index) in objUserHouseInfo" :key="item.key + index" :style="{'width':index == 0?'28% !important':''}">
                        <p class="key">{{ item.key }}</p>
                        <p class="value">{{ item.value }}</p>
                    </div>
                </div>

                <!--        悬浮标签        -->
                <!-- <div class="abs-tag">{{ '空调壁挂炉' }}</div> -->
            </div>
            <!--     状态信息       -->
            <div class="status-info-content">
                <div class="status-item" :class="{'status-item-active': item.state < 2}" v-for="(item,index) in arrConstStateList" :key="index" :style="{'width':100 /arrConstStateList.length + '%'}">
                    <p class="status-name">{{ item.sum_name }}</p>
                    <div class="statu-image">
                        <img :src="require('@/assets/images/user/house/project-team-finish-icon.png')" class="icon" v-if="item.state < 2" alt="">
                        <img :src="require('@/assets/images/user/house/project-team-finish-no-icon.png')" class="icon" v-else alt="">
                        <div class="xian" v-if="index != arrConstStateList.length - 1"></div>
                    </div>
                    <p class="status-text" :class="{'len-status-text':item.name.split('').length > 4}">{{ item.name }}</p>
                </div>
            </div>
        </div>
        <!--     报告标题    -->
        <div class="report-name">
            <p style="text-align: center;">{{ activeReportName.title }}</p>
            <!-- <img :src="require('@/assets/images/user/house/completion-tip-icon.png')" alt="" class="icon"> -->
        </div>

        <!--    报告列表    -->
        <div class="report-list-wrap">
            <div class="report-item" v-for="(report,rIndex) in arr" :key="rIndex">
                <!--        报告标题        -->
                <div class="title-content" :class="{'wait-title-content' :  report.status === 1,'confirm-title-content':  report.status === 2}">
                    <p class="context">{{ report.title }}</p>
                    <div class="status-btn">{{ report.status === 0 ? '待交付' : report.status === 1 ? '待确认' : '已确认' }}</div>
                </div>
                <!--       报告展示内容         -->
                <div class="show-content" v-if="report.status !== 0">
                    <!--           图片信息         -->
                    <div class="image-list">
                        <div class="images">
                            <div class="image" v-for="(image,imgIndex) in report.imageList.slice(0,3)" :key="imgIndex" alt=""></div>
                        </div>
                        <!--        附加内容        -->
                        <div class="pro-info">
                            <!--        合格标识        -->
                            <img v-if="report.status === 2" class="confirm-icon" :src="require('@/assets/images/user/house/completion-working-confirm-icon.png')" alt="">
                            <!--       检验信息        -->
                            <div v-if="report.status === 1" class="programs">
                                <p>{{ 6 }}个工序</p>
                                <p>{{ 35 }}个质控点</p>
                            </div>
                        </div>
                    </div>
                    <!--        评论信息            -->
                    <div v-if="report.status === 2" class="eva-context-info">
                        <div class="title">
                            <p>客户星级评价</p>
                            <img :src="require('@/assets/images/user/house/completion-star-icon.png')" v-for="item in report.userScore" :key="item" alt="">
                            <div>5.0分</div>
                        </div>
                        <div class="tags">
                            <div class="tags_item" v-for="(tags,tagNum) in tag_name" :key="tagNum">{{tags}}</div>
                        </div>
                        <p class="eva-text">{{ '施工严谨，施工时未监工，觉得史密斯是个大公司，就特别信任' }}</p>
                    </div>
                    <!--         操作按钮           -->
                    <div class="action-btn">
                        <div @click="changeConfirmPopupVisible" v-if="report.status === 1" class="action-item">
                            <img class="icon" :src="require('@/assets/images/user/house/completion-confrim-icon.png')" alt="">
                            <p class="text confirm">确认验收</p>
                        </div>
                        <div class="action-item" @click="getRouter(report.arrContent,report)">
                            <img class="icon" :src="require('@/assets/images/user/house/completion-confrim-ok-icon.png')" alt="">
                            <p class="text">查看详情</p>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <!--     确认验收弹窗      -->
        <Popup v-model="bConfirmPopupVisible" class="confirm-cover-popup">
            <!--            标题      -->
            <p class="title">{{ '对本次空调隐蔽工程的验收是否满意' }}</p>
            <!-- <p class="star-text">{{ '非常满意，无可挑剔' }}</p> -->
            <startEvaluate @scoreChange="scoreChange"></startEvaluate>
            <!--     标签       -->
            <div class="tags-content">
                <div @click="changeTagActive(tag.id)" v-for="(tag,tagIndex) in arrAcceptance" :key="tagIndex" class="tags-item" :class="{'tags-item-active':arrAcceptanceActive.includes(tag.id)}">
                    <p>{{ tag.name }}</p>
                    <!-- <img v-if="arrAcceptanceActive.includes(tag.id)" class="active-icon" :src="require('@/assets/images/user/house/completion-select-icon.png')" alt=""> -->
                </div>
            </div>
            <!--    文本输入控件       -->
            <div style="display:flex;">
                <span style="color:red;" v-if="nUserScore <= 3">*</span>
                <textarea class="text-input" placeholder="其他想说的" />
            </div>
            <!--        提交按钮    -->
            <div class="commit-button">提交评价</div>
        </Popup>

        <!--    报告选择弹窗     -->
        <Popup position="bottom" v-model="bReportSwitchVisible" class="report-switch-popup">
            <VantPicker :columns="arrReportNameList" value-key="name" show-toolbar @confirm="reportPickerConfirm" @cancel="changeReportSwitchPopupVisible" />
        </Popup>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { Popup, Picker } from "vant";
import startEvaluate from "@/page/service/components/startevaluate";
import oDeliver from "@/js/deliver.js";

export default {
    name: "completion",
    data() {
        return {
            tag_name: ["及时预约", "施工标准严苛"],
            // 用户房屋信息
            objUserHouseInfo: [
                {
                    key: "户型",
                    value: "四室二厅二卫一厨",
                },
                {
                    key: "面积",
                    value: "158 ㎡",
                },
                {
                    key: "房屋类型",
                    value: "大平层",
                },
                {
                    key: "系统产品",
                    value: "冷暖风水",
                },
            ],
            arr: [
                {
                    title: "新风系统施工监理报告",
                    status: 2, // 0默认状态  1待确认 2已确认
                    userScore: 5, // 用户评分
                    userEvaText:
                        "每个机器安装的地方都已示范标准，施工准备工作很认真", // 评论内容
                    imageList: ["", "", "", "", ""], // 图像列表
                    arrTag: [
                        {
                            name: "新风主机",
                            num: "5",
                            type: 1,
                            arrChlick: [
                                {
                                    arrImg: [
                                        {
                                            url: require("@/assets/images/shigong/新风主机.png"),
                                        },
                                    ],
                                    arrZhikun: [
                                        {
                                            name: "主机吊装牢固、水平;且下部固定采用双螺母或螺母加弹簧垫圈防松脱",
                                            help: "防松脱设置，双螺母固定有减震措施减少运行过程中的震动，起到很好的降噪左右。",
                                            zhen: "是",
                                            cuo: "否",
                                        },
                                        {
                                            name: "主机与顶面之间间距___mm",
                                            zhen: "是",
                                            cuo: "否",
                                        },
                                        {
                                            name: "主机防尘保护",
                                            zhen: "有",
                                            cuo: "无",
                                        },
                                        {
                                            name: "主机检修口位置标识清楚并标注尺寸",
                                            zhen: "清楚",
                                            cuo: "不清楚",
                                        },
                                        {
                                            name: "主机检修口至机器间，吊顶区域内无有障碍物",
                                            zhen: "无",
                                            cuo: "有",
                                        },
                                    ],
                                },
                            ],
                        },
                        {
                            name: "新风风管安装",
                            num: "5",
                            type: 1,
                            arrChlick: [
                                {
                                    name: "新风风管",
                                    arrImg: [
                                        {
                                            url: require("@/assets/images/shigong/新风风管.png"),
                                        },
                                    ],
                                    arrZhikun: [
                                        {
                                            name: "连接室外侧的风管保温",
                                            help: "保温防结露，防止后期出现冷凝水，损坏用户吊顶",
                                            zhen: "有保温",
                                            cuo: "无保温",
                                        },
                                        {
                                            name: "直管间距 700-1000mm，弯管处 300mm 有无支撑吊卡",
                                            zhen: "有",
                                            cuo: "无",
                                        },
                                        {
                                            name: "管段连接规范且有效密封",
                                            zhen: "是",
                                            cuo: "否",
                                        },
                                        {
                                            name: "末端风管与主管软接",
                                            zhen: "牢固",
                                            cuo: "不牢固",
                                        },
                                    ],
                                },
                                {
                                    name: "静压分风箱",
                                    arrImg: [
                                        {
                                            url: require("@/assets/images/shigong/静压分风箱.png"),
                                        },
                                    ],
                                    arrZhikun: [
                                        {
                                            name: "分风箱带有调节风阀",
                                            zhen: "有",
                                            cuo: "无",
                                        },
                                    ],
                                },
                            ],
                        },
                        {
                            name: "新风末端",
                            num: "1",
                            type: 1,
                            arrChlick: [
                                {
                                    arrImg: [],
                                    arrZhikun: [
                                        {
                                            name: "风管穿墙安装规范符合要求",
                                            zhen: "规范",
                                            cuo: "不规范",
                                        },
                                    ],
                                },
                            ],
                        },
                        {
                            name: "新风风管",
                            num: "3",
                            type: 1,
                            arrChlick: [
                                {
                                    arrImg: [
                                        {
                                            url: require("@/assets/images/shigong/房间风口.png"),
                                        },
                                    ],
                                    name: "房间风口",
                                    arrZhikun: [
                                        {
                                            name: "每个风口风速测试___m/s",
                                            zhen: "是",
                                            cuo: "是",
                                        },
                                        // {
                                        //     name: "送回风口位置尺寸标识",
                                        //     zhen: "清楚",
                                        //     cuo: "不清楚",
                                        // },
                                    ],
                                },
                            ],
                        },
                    ],
                },
                {
                    title: "空调隐蔽系统施工监理报告",
                    status: 1, // 0默认状态  1待确认 2已确认
                    imageList: ["", "", "", "", ""], // 图像列表
                    programs: {
                        process: 6, // 工序
                        qcCount: 18, // 质控数
                    },
                    arrTag: [
                        {
                            name: "风机盘管安装",
                            num: "4",
                            type: 1,
                            arrChlick: [
                                {
                                    name: "风盘接管侧保温",
                                    arrImg: [],
                                    arrZhikun: [
                                        {
                                            name: "风盘侧接水管保温棉是否紧贴风盘侧壁",
                                            zhen: "紧贴",
                                            cuo: "未紧贴",
                                        },
                                        {
                                            name: "进出水管保温厚度__mm",
                                            zhen: "是",
                                            cuo: "否",
                                        },
                                        {
                                            name: "保温接缝处",
                                            zhen: "粘贴胶带紧固",
                                            cuo: "未粘贴未紧固",
                                        },
                                        {
                                            name: "阀件有无漏铜，漏缝隙，被压缩",
                                            zhen: "无",
                                            cuo: "有",
                                        },
                                    ],
                                },
                                {
                                    name: "风机盘管",
                                    arrImg: [
                                        {
                                            url: require("@/assets/images/shigong/风机盘管.png"),
                                        },
                                    ],
                                    arrZhikun: [
                                        {
                                            name: "风盘双螺母固定且有无减震垫",
                                            zhen: "有",
                                            cuo: "无",
                                            help: "1、风盘吊杆位置使用减震垫，减少运行噪音；<br>2、双螺母固定，提升安装可靠性",
                                        },
                                        {
                                            name: "风机盘管防尘保护",
                                            zhen: "有",
                                            cuo: "无",
                                        },
                                        {
                                            name: "风机盘管检修空间满足要求且标记清晰",
                                            zhen: "清晰",
                                            cuo: "不清晰",
                                        },
                                        {
                                            name: "风盘帆布满足防水、防霉保温防凝露",
                                            zhen: "满足",
                                            cuo: "不满足",
                                        },
                                        {
                                            name: "风机盘管安装顶部与顶面间距__mm",
                                            zhen: "是",
                                            cuo: "否",
                                            help: "4、距顶部≥5mm，预防机器与墙体产生共振、出现噪音",
                                        },
                                        {
                                            name: "出风口帆布软接与机器之间采用压条固定",
                                            zhen: "采用",
                                            cuo: "不采用",
                                        },
                                        {
                                            name: "下送下回风口之间的中心距___m",
                                            zhen: "是",
                                            cuo: "否",
                                            help: "下送下回风口之间的中心距___m(大于 1.2m)"
                                        },
                                        {
                                            name: "风盘出风口以及回风口尺寸位置标识清晰",
                                            zhen: "清晰",
                                            cuo: "不清晰",
                                        }
                                    ],
                                },
                            ],
                        },
                        {
                            name: "风机盘管",
                            num: "4",
                            type: 1,
                            arrChlick: [
                                {
                                    name: "风机盘管整机",
                                    arrImg: [
                                        {
                                            url: require("@/assets/images/shigong/风机盘管.png"),
                                        },
                                    ],
                                    arrZhikun: [
                                        {
                                            name: "风盘及冷凝水水管朝向排水侧倾斜",
                                            zhen: "是",
                                            cuo: "否",
                                        },
                                    ],
                                },
                            ],
                        },
                        {
                            name: "氟水换热器安装",
                            num: "8",
                            type: 1,
                            arrChlick: [
                                {
                                    name: "氟水换热器",
                                    arrImg: [
                                        {
                                            url: require("@/assets/images/shigong/氟水换热器.png"),
                                        },
                                    ],
                                    arrZhikun: [
                                        {
                                            name: "水力模块检修空间满足要求且标记清晰",
                                            zhen: "是",
                                            cuo: "否",
                                        },
                                        {
                                            name: "吊顶水力模块双螺母固定且有无加减震垫",
                                            zhen: "是",
                                            cuo: "否",
                                        },
                                        {
                                            name: "吊顶式水力模块安装顶部与顶面间距__mm",
                                            help: "2、距顶部≥5mm，预防机器与墙体产生共振、出现噪音",
                                            zhen: "是",
                                            cuo: "否",
                                        },
                                        {
                                            name: "冷凝水排水管是否按坡度要求",
                                            help: "1、向冷凝水口方向倾斜，便于冷凝水排出（适用于吊顶式氟水换热器）",
                                            zhen: "是",
                                            cuo: "否",
                                        },
                                        {
                                            name: "吊顶式水力模块泄压阀、排气阀安装",
                                            zhen: "安装",
                                            cuo: "未安装",
                                        },
                                        {
                                            name: "冷凝水软接卡箍牢靠，无漏水，弯曲不大于90°",
                                            zhen: "是",
                                            cuo: "否",
                                        },
                                    ],
                                },
                                {
                                    name: "氟水换热器接管侧保温",
                                    arrImg: [],
                                    arrZhikun: [
                                        {
                                            name: "接水管侧保温棉是否紧贴内机侧壁并刷胶粘粘",
                                            zhen: "是",
                                            cuo: "否",
                                        },
                                        {
                                            name: "接管侧阀件保温有无漏铜，漏缝隙，被压缩",
                                            zhen: "无",
                                            cuo: "有",
                                        },
                                    ],
                                },
                            ],
                        },
                        {
                            name: "核心阀件安装",
                            num: "4",
                            type: 1,
                            arrChlick: [
                                {
                                    name: "压差旁通",
                                    arrImg: [
                                        {
                                            url: require("@/assets/images/shigong/压差旁通.png"),
                                        },
                                    ],
                                    arrZhikun: [
                                        {
                                            name: "压差旁通安装方向",
                                            help: "安装于空调系统最末端，控制系统用水流量，减少机组故障，冬季自动循环防止系统冻坏。",
                                            zhen: "正确",
                                            cuo: "不正确",
                                        },
                                    ],
                                },
                                {
                                    name: "排气阀",
                                    arrImg: [
                                        {
                                            url: require("@/assets/images/shigong/排气阀.png"),
                                        },
                                    ],
                                    arrZhikun: [
                                        {
                                            name: "微泡排气阀是否安装排气引流管",
                                            help: "安装于系统主管路高温低压区，排出管路内空气，减少异响，同时确保系统用水充盈，高效散冷、散热",
                                            zhen: "安装",
                                            cuo: "未安装",
                                        },
                                        {
                                            name: "微泡排气阀是否保温严实无开裂",
                                            zhen: "是",
                                            cuo: "否",
                                        },
                                    ],
                                },
                                {
                                    name: "过滤器",
                                    arrImg: [
                                        {
                                            url: require("@/assets/images/shigong/过滤器.png"),
                                        },
                                    ],
                                    arrZhikun: [
                                        {
                                            name: "过滤器安装方向",
                                            help: "安装在氟水换热器进水口，过滤水中杂质，保护换热器及系统管路",
                                            zhen: "正确",
                                            cuo: "不正确",
                                        },
                                    ],
                                },
                            ],
                        },
                        {
                            name: "系统管路安装",
                            num: "5",
                            type: 1,
                            arrChlick: [
                                {
                                    name: "吊杆",
                                    arrImg: [
                                        {
                                            url: require("@/assets/images/shigong/管路吊杆.jpeg"),
                                        },
                                    ],
                                    arrZhikun: [
                                        {
                                            name: "管路吊杆间距合理并用不锈吊杆",
                                            help: "吊箍宽度不低于35mm，防止保温层局部变薄、保温失效",
                                            zhen: "是",
                                            cuo: "否",
                                        },
                                    ],
                                },
                            ],
                        },
                        {
                            name: "系统管路",
                            num: "4",
                            type: 1,
                            arrChlick: [
                                {
                                    name: "系统主管与支管",
                                    arrImg: [],
                                    arrZhikun: [
                                        {
                                            name: "管道保温层有无压缩",
                                            zhen: "无",
                                            cuo: "有",
                                        },
                                    ],
                                },
                                {
                                    name: "冷凝水管",
                                    arrImg: [
                                        {
                                            url: require("@/assets/images/shigong/冷凝水管.png"),
                                        },
                                    ],
                                    arrZhikun: [
                                        {
                                            name: "冷凝水管保温层厚度≥9mm，并且无压缩",
                                            zhen: "是",
                                            cuo: "否",
                                        },
                                        {
                                            name: "风机盘管的冷凝水管独立设置通气口、冷凝水汇流管长度＞6m 时加设通气口",
                                            zhen: "是",
                                            cuo: "否",
                                        },
                                        {
                                            name: "冷凝水管通气口的开口方向朝下或朝上有防尘帽",
                                            help: "每6米安装一个排气口，平衡管路内外压力，提升冷凝水排放速度",
                                            zhen: "是",
                                            cuo: "否",
                                        },
                                        {
                                            name: "冷凝水主管汇流是否错位连接",
                                            help: "排气口弯曲朝下，防灰尘、蚊虫进入",
                                            zhen: "错位连接",
                                            cuo: "错位连接",
                                        },
                                        {
                                            name: "冷凝水进行每台内机100%通水试验",
                                            zhen: "排水顺畅",
                                            cuo: "排水顺畅",
                                        },
                                    ],
                                },
                                {
                                    name: "穿墙保温",
                                    arrImg: [
                                        {
                                            url: require("@/assets/images/shigong/穿墙保温.jpeg"),
                                        },
                                    ],
                                    arrZhikun: [
                                        {
                                            name: "过墙段管道套保温层厚度___mm",
                                            zhen: "是",
                                            cuo: "否",
                                        },
                                        {
                                            name: "穿墙孔（是/否）使用发泡剂或者胶泥密封",
                                            zhen: "紧贴",
                                            cuo: "未紧贴",
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                },
                {
                    title: "采暖隐蔽系统施工监理报告",
                    status: 0, // 0默认状态  1待确认 2已确认
                },
            ],
            // 项目的状态数组
            arrConstStateList: [
                {
                    name: "进场定位",
                    state: 0,
                    sum_name: "已完工",
                },
                {
                    name: "新风系统施工",
                    state: 1,
                    sum_name: "已完工",
                },
                {
                    name: "空调隐蔽系统施工",
                    state: 1,
                    sum_name: "已完工",
                },
                {
                    name: "采暖隐蔽系统施工",
                    state: 3,
                    sum_name: "未开工",
                },
            ],
            // tag评分星星
            nUserScore: 5,
            // 确认验收弹窗显示
            bConfirmPopupVisible: false,
            // 报告选择弹窗
            bReportSwitchVisible: false,
            // 验收服务项
            arrAcceptance: [],
            // 验收项激活
            arrAcceptanceActive: [],
        };
    },
    components: {
        Popup,
        VantPicker: Picker,
        startEvaluate,
    },
    computed: {
        ...mapState({
            // 报告列表
            arrReportList: (state) => state.userHouseCompletion.arrReportList,
            // 主报表切换列表
            arrReportNameList: (state) =>
                state.userHouseCompletion.arrReportNameList,
        }),
        // 当前激活的主报告
        activeReportName() {
            return this.$store.getters["userHouseCompletion/activeReportName"];
        },
    },
    created() {
        let _that = this;
        $init(() => {
            _that.getMemberTag();
            // console.log(this.$store.state.completion);
        });
    },
    methods: {
        getRouter(content, report) {
            this.$storage.setStorage("arrReport", report);
            this.$router.push({
                path: "/user/house/completed",
                query: { status: report.status, text: report.title },
            });
        },
        /**
         * 改变验收弹窗显示
         */
        changeConfirmPopupVisible() {
            this.bConfirmPopupVisible = !this.bConfirmPopupVisible;
        },
        /**
         * 改变验收激活项员素
         * @param {string} tag
         */
        changeTagActive(tag) {
            this.arrAcceptanceActive.includes(tag)
                ? (this.arrAcceptanceActive = this.arrAcceptanceActive.filter(
                      (i) => i !== tag
                  ))
                : this.arrAcceptanceActive.push(tag);
        },
        /**
         * 改变报告选择弹窗显示
         */
        changeReportSwitchPopupVisible() {
            this.bReportSwitchVisible = !this.bReportSwitchVisible;
        },
        // 获取星星评价
        scoreChange(e) {
            this.nUserScore = e;
            this.getMemberTag();
        },
        // 评价tag
        getMemberTag() {
            let _that = this;
            this.$store.commit("loadSkeleton", { bool: true, type: "report" }); // 页面loading开启
            oDeliver.getMemberTag({ rank: _that.nUserScore }).then((res) => {
                this.$store.commit("loadSkeleton", {
                    bool: false,
                    type: "report",
                }); // 页面loading开启
                _that.arrAcceptance = res.result;
            });
        },
        /**
         * 主报告选择器确认
         * @param id
         */
        reportPickerConfirm({ id }) {
            this.$store.commit({
                type: "userHouseCompletion/CHANGE_REPORT_ACTIVE_ID",
                id,
            });
            this.changeReportSwitchPopupVisible();
        },
    },
};
</script>

<style scoped lang="scss">
::v-deep .van-overlay {
    z-index: 99 !important;
}
.completion-page {
    background: $defaultBackgroundGary;
    min-height: 100vh;
    padding: 28px 24px 32px;
    font-size: $baseSize;

    .construction-status {
        border-radius: $commonRadius;
        margin-bottom: 28px;
        overflow: hidden;
        font-size: $smallSize;
        color: #ffffff;

        .room-basic-info-content {
            background: $deepGreen;
            padding: 16px 0 28px;
            position: relative;

            .abs-tag {
                width: 160px;
                height: 44px;
                background: #81c169;
                line-height: 44px;
                text-align: center;
                position: absolute;
                right: 0;
                top: 0;
                border-bottom-left-radius: $commonRadius;
            }

            .owner-info {
                padding: 0 4px;
                justify-content: space-between;
                align-items: center;
                display: flex;
                margin-bottom: 24px;

                .head-image {
                    flex: 0;
                    width: 132px;
                    height: 132px;
                    margin-right: 4px;
                }

                .text-content {
                    flex: 1;
                    padding: 16px 0;

                    .address {
                        width: 96%;
                        // white-space: nowrap;
                        // overflow: hidden;
                        // text-overflow: ellipsis;
                        text-align: justify;
                        font-size: 36px;
                        font-weight: 500;
                        line-height: 50px;
                        margin-bottom: 10px;
                    }

                    .name {
                        line-height: 40px;
                        color: #ffe56e;
                        display: flex;
                        align-items: center;

                        .first {
                            font-size: $baseSize;
                            margin-right: 16px;
                            color: rgba(#ffffff, 0.8);
                        }
                    }
                }
            }

            .room-info {
                display: flex;
                align-items: center;
                justify-content: space-between;

                .room-info-item {
                    width: 23%;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;

                    .key {
                        line-height: 36px;
                        color: rgba(#ffffff, 0.6);
                        margin-bottom: 16px;
                    }

                    .value {
                        line-height: 32px;
                    }
                }
            }
        }

        .status-info-content {
            width: 100%;
            display: flex;
            // align-items: center;
            // justify-content: center;
            padding: 28px 0;
            // background: linear-gradient(#fff, #fff) no-repeat left 46px / 70px
            //         10px,
            //     linear-gradient(#fff, #fff) no-repeat right 46px / 70px 10px,
            //     linear-gradient(to right, #c8e1ce 50%, transparent 50%) repeat-x
            //         left 46px / 12px 2px;
            background-color: #ffffff;
            overflow: auto;
            .status-item {
                position: relative;
                // flex: 0 0 calc(100% / 6);
                color: #a2a2a2;
                display: flex;
                flex-direction: column;
                // justify-content: center;
                align-items: center;
                .statu-image {
                    width: 36px;
                    height: 36px;
                    margin-bottom: 14px;
                    img {
                        position: relative;
                        z-index: 1;
                        width: 100%;
                        height: 100%;
                    }
                    .xian {
                        position: absolute;
                        border-bottom: 1px dashed #c8e1ce;
                        height: 1px;
                        width: 100%;
                        top: 62px;
                        z-index: 0;
                    }
                }
                .icon {
                    width: 36px;
                    height: 36px;
                    margin-bottom: 14px;
                }

                .status-text {
                    width: 50px;
                    line-height: 34px;
                    text-align: center;
                }

                .len-status-text {
                    width: 100px;
                }
                .status-name {
                    margin-bottom: 14px;
                }
            }

            .status-item-active {
                color: #649559;
            }
        }
    }

    .report-name {
        padding: 26px 24px;
        background: #ffffff;
        line-height: 40px;
        border-radius: $commonRadius;
        color: $deepGreen;
        font-size: $baseSize;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 24px;

        p {
            width: 100%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .icon {
            width: 28px;
            height: 28px;
            margin-left: 28px;
        }
    }

    .report-list-wrap {
        .report-item {
            margin-bottom: 24px;
            border-radius: $commonRadius;
            overflow: hidden;

            .title-content {
                background: #6c9276;
                height: 100px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding-left: 28px;
                border-radius: $commonRadius;
                color: #6c9276;

                .context {
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    width: 100%;
                    color: #ffffff;
                    font-size: $bigSize;
                    font-weight: 500;
                }

                .status-btn {
                    width: 114px;
                    height: 44px;
                    border-radius: 44px;
                    line-height: 44px;
                    font-size: $smallSize;
                    text-align: center;
                    background: #ffffff;
                    margin: 0 24px;
                }
            }

            .wait-title-content {
                background: #e3a751;
                color: #e3a751;
            }

            .confirm-title-content {
                background: $greenGradient;
                color: $deepGreen;
            }

            .show-content {
                background: #ffffff;
                padding: 0 24px;

                .image-list {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 28px 0 32px;
                    background: linear-gradient(
                            to right,
                            #f1f1f1 50%,
                            transparent 50%
                        )
                        repeat-x left bottom / 16px 2px;
                    position: relative;
                    margin-bottom: 26px;

                    .images {
                        flex: 1;
                        height: 120px;

                        .image {
                            display: inline-block;
                            width: 120px;
                            height: 120px;
                            margin-right: 24px;
                            border-radius: $commonRadius;
                            background: #f7f7f7;
                        }
                    }

                    .pro-info {
                        position: absolute;
                        min-width: 160px;
                        right: 0;
                        top: 10px;

                        .confirm-icon {
                            width: 160px;
                            height: 160px;
                        }

                        .programs {
                            color: #e3a751;
                            width: 186px;
                            margin-top: 34px;

                            p {
                                line-height: 40px;

                                &:first-child {
                                    margin-bottom: 10px;
                                }
                            }
                        }
                    }
                }

                .eva-context-info {
                    background: linear-gradient(
                            to right,
                            #f1f1f1 50%,
                            transparent 50%
                        )
                        repeat-x left bottom / 16px 2px;
                    padding-bottom: 34px;
                    margin-bottom: 28px;
                    .tags {
                        display: flex;
                        align-items: center;
                        flex-wrap: wrap;
                        // margin-bottom: 20px;
                        .tags_item {
                            padding: 5px 10px;
                            box-sizing: border-box;
                            border-radius: 8px;
                            border: 2px solid rgba(49, 133, 68, 0.3);
                            color: #3d8f50;
                            font-size: 24px;
                            margin-right: 20px;
                            margin-bottom: 20px;
                        }
                    }
                    .title {
                        display: flex;
                        align-items: center;
                        margin-bottom: 16px;

                        & :first-child {
                            line-height: 40px;
                            margin-right: 24px;
                        }

                        img {
                            width: 32px;
                            height: 32px;
                            margin-right: 16px;
                        }
                    }

                    .eva-text {
                        line-height: 32px;
                        color: #a2a2a2;
                    }
                }

                .action-btn {
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    color: #a2a2a2;

                    .action-item {
                        display: flex;
                        align-items: center;
                        padding-bottom: 28px;
                        box-sizing: border-box;

                        .text {
                            line-height: 40px;
                        }

                        .confirm {
                            color: $deepGreen;
                        }

                        .icon {
                            width: 36px;
                            height: 36px;
                            margin-right: 8px;
                            margin-left: 40px;
                        }
                    }
                }
            }
        }
    }

    .confirm-cover-popup {
        width: 580px;
        // height: 790px;
        border-radius: $commonRadius;
        background: #ffffff;
        padding: 40px 24px 32px;
        z-index: 100 !important;

        .title {
            color: $commonTitle;
            font-weight: 500;
            margin-bottom: 28px;
            line-height: 40px;
            text-align: center;
        }

        .star-text {
            color: #eb6f56;
            font-weight: 500;
            margin-bottom: 12px;
            line-height: 40px;
            text-align: center;
        }

        .tags-content {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            margin-bottom: 8px;

            .tags-item {
                width: 256px;
                height: 80px;
                border: 2px solid #858585;
                border-radius: $commonRadius;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #858585;
                position: relative;
                margin-bottom: 20px;

                .active-icon {
                    width: 36px;
                    height: 36px;
                    position: absolute;
                    right: 12px;
                }
            }

            .tags-item-active {
                color: #fff;
                border-color: $deepGreen;
                background: $deepGreen;
            }
        }

        .text-input {
            height: 194px;
            padding: 24px 20px;
            background: #f7f7f7;
            border-radius: $commonRadius;
            width: 100%;
            resize: none;
            margin-bottom: 28px;
        }

        .commit-button {
            width: 532px;
            height: 92px;
            background: $greenGradient;
            border-radius: $commonRadius;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #ffffff;
            font-weight: 500;
            font-size: $bigSize;
        }
    }

    .report-switch-popup {
        border-radius: $commonRadius $commonRadius 0 0;
    }
}
</style>